import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportRouteSearchData } from "../../../../models/FacilityReportData";
import LineChart from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";

interface IRouteSearchSectionProps {
  routeSearch?: FacilityReportRouteSearchData;
  isDownloading: boolean;
}

export const RouteSearchSection: React.FunctionComponent<
  IRouteSearchSectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const { routeSearch, isDownloading } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">(
    routeSearch?.time_unit ?? "day"
  );

  if (!routeSearch) {
    return null;
  }

  return (
    <div className="route-search-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-route-search-section"
      >
        <h2>{t("routeSearchSection.title")}</h2>
        {!routeSearch.route_search_data ? (
          <p className="no-data-message">{t("no_data")}</p>
        ) : (
          <>
            {routeSearch.ai_summary && (
              <p className="ai-summary">{routeSearch.ai_summary}</p>
            )}
            <LineChart
              chartDetailsData={routeSearch.route_search_data}
              usePrevYear={false}
              timeUnit={timeUnit}
              skipLabelTranslation={false}
              setTimeUnit={setTimeUnit}
              showTimeUnitSelect={!isDownloading}
            />
          </>
        )}
      </div>
    </div>
  );
};
